<template>
    <nav class='navigation'>
        <router-link class='navigation-link' to='/'>about</router-link>
        <router-link class='navigation-link' to='/projects'>projects</router-link>
        <router-link class='navigation-link' to='/more'>more</router-link>
    </nav>
</template>

<script>
export default {
    name: 'Navigation',
}
</script>

<style lang="less" scoped>
@import '../colours';

.navigation {
    position: fixed;
    left: 30px;
    top: calc(~"50vh + 100px");
    display: flex;
    flex-direction: column;
    background: black;
}

.navigation-link {
    margin: 10px;
    color: white;
    text-decoration: none;

    &:hover {
        font-weight: bold;
    }
}

@media screen and (max-width: 960px) {
    .navigation {
        left: 80px;
        top: 30px;
        flex-direction: row;
    }
}

@media screen and (max-width: 550px) {
    .navigation {
        left: 20px;
        top: 10px;
    }
}


</style>